// Auto-generated from segment.spec.js
export default {
  "tagName": "ui-segments",
  "types": [
    "raised",
    "stacked",
    "piled",
    "horizontal"
  ],
  "variations": [
    "compact",
    "basic"
  ],
  "attributes": [
    "raised",
    "stacked",
    "piled",
    "compact",
    "basic",
    "horizontal"
  ],
  "optionAttributes": {
    "compact": "compact",
    "very-compact": "compact"
  },
  "propertyTypes": {
    "raised": "boolean",
    "stacked": "boolean",
    "piled": "boolean",
    "compact": "string",
    "basic": "boolean",
    "horizontal": "boolean"
  },
  "allowedValues": {
    "compact": [
      "compact",
      "very"
    ]
  },
  "inheritedPluralVariations": [
    "compact",
    "basic"
  ]
};
